/**
 * @file Overlay de carga inicial de la SPA.
 * @module appLoader
 */

const LOADER_ID = "appLoader";

/**
 * Oculta el loader de pantalla completa (fade-out y luego `hidden`).
 */
export function hideAppLoader() {
	const el = document.getElementById(LOADER_ID);
	if (!el || el.hidden) return;

	el.classList.add("app-loader--hidden");
	el.setAttribute("aria-busy", "false");
	el.setAttribute("aria-hidden", "true");

	let done = false;
	const finish = () => {
		if (done) return;
		done = true;
		el.hidden = true;
	};
	el.addEventListener("transitionend", finish, { once: true });
	window.setTimeout(finish, 300);
}
